import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { NavContext } from "../../App";
import { decryptData } from "../../utils/cryptoUtils";

const FIO_MANAGER_ORIGINS = [
  "http://localhost:3000",
  "https://fiomanager.frenchinnov.fr",
  "https://dev-fiomanager.frenchinnov.fr",
  "http://dev-fiomanager.frenchinnov.fr",
  "http://fiomanager.frenchinnov.fr",
];
const AUTO_LOGIN_TIMEOUT_MS = 5000;

function AutoLoginWithToken() {
  const { setLogged, setAutoLoginPending } = useContext(NavContext);
  const navigate = useNavigate();

  useEffect(() => {
    const embeddedInFioManager = window.parent !== window;
    if (!embeddedInFioManager) {
      localStorage.setItem("iframeAutoLogin", "false");
      return;
    }

    // Si FioManager ne répond pas (origine non listée, etc.), on retombe sur le login.
    const fallbackToLogin = setTimeout(() => setAutoLoginPending(false), AUTO_LOGIN_TIMEOUT_MS);

    const handleAutoLogin = (event) => {
      if (
        !FIO_MANAGER_ORIGINS.includes(event.origin) ||
        event.data?.type !== "FIO_AUTO_LOGIN"
      ) {
        return;
      }

      clearTimeout(fallbackToLogin);

      try {
        const decrypted = decryptData(event.data.encryptedData);

        const bearerToken = "Bearer " + decrypted?.user?.userToken;
        localStorage.setItem("TokenStored", bearerToken);
        localStorage.setItem("Token", decrypted?.user?.userToken);
        localStorage.setItem("userId", decrypted?.user?.id || decrypted?.id);
        localStorage.setItem(
          "userlastName",
          decrypted?.user?.lastName || decrypted?.user?.firstName
        );
        localStorage.setItem("iframeAutoLogin", "true");

        // Les trois mises à jour sont regroupées dans un seul rendu : les routes
        // réapparaissent déjà sur /dashboard, le login n'est jamais affiché.
        setLogged(true);
        navigate("/dashboard");
      } catch (err) {
        console.error("Invalid token", err);
      } finally {
        setAutoLoginPending(false);
      }
    };

    window.addEventListener("message", handleAutoLogin);
    window.parent.postMessage({ type: "SAV_READY" }, "*");

    return () => {
      clearTimeout(fallbackToLogin);
      window.removeEventListener("message", handleAutoLogin);
    };
  }, [setLogged, setAutoLoginPending, navigate]);

  return null;
}

export default AutoLoginWithToken;
